export const LOGIN = "LOGIN";

export const LOGOUT = "LOGOUT";

export const FETCH_USER_ACCESS_SUCCESS = "FETCH_USER_ACCESS_SUCCESS";
